function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "F8EA4E06-8F7F-46B8-BA20-CB4B06E3D18F");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null);

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "HOME",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "FOOTER_DESKTOP",
  transform: "translate(-323.000000, -102.000000)",
  fill: "#FFFFFF"
}, /*#__PURE__*/React.createElement("path", {
  d: "M325.848105,125.348222 L325.848105,114.392514 L323,114.392514 L323,110.447787 L325.848105,110.447787 L325.848105,107.078634 C325.848105,104.431078 327.530515,102 331.407026,102 C332.976634,102 334.137515,102.153047 334.137515,102.153047 L334.04585,105.836594 C334.04585,105.836594 332.862157,105.824887 331.570475,105.824887 C330.172478,105.824887 329.948547,106.480071 329.948547,107.567787 C329.948547,108.42753 329.948547,105.735273 329.948547,110.448 L334.156978,110.448 L333.973857,114.392727 L329.948547,114.392727 L329.948547,125.348435 L325.848105,125.348435 L325.848105,125.348222 Z",
  id: "Shape-3-Copy"
})));

var SvgEroskiFooter2Facebook = function SvgEroskiFooter2Facebook(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "24px",
    viewBox: "0 0 12 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEroskiFooter2Facebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eroski-footer2-facebook.3842a063.svg";
export { ForwardRef as ReactComponent };